import styled from 'styled-components';
import { Icon } from '../../../../../../../../Icons';
export const Container = styled.div `
    display: flex;
    width: 100%;
    flex-direction: row;
    margin-top: 16px;
    box-sizing: border-box;
    align-items: center;
    cursor: pointer;

    &:last-of-type {
        margin-bottom: 16px;
    }
`;
export const StyledIcon = styled(Icon) `
    width: 24px;
    height: 24px;
    margin: 0 10px;
    opacity: ${(props) => (props.isActive ? 1 : 0)};
`;
//# sourceMappingURL=index.js.map